export class CookieManager {

    setCookie(key: string, value: string, options?: { expires?: Date | number; path?: string; secure?: boolean; sameSite?: 'Strict' | 'Lax' | 'None' }) {
        let cookieString = `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;

        if (options) {
            if (options.expires) {
                if (typeof options.expires === 'number') {
                    const date = new Date();
                    date.setTime(date.getTime() + options.expires * 1000); // Convert seconds to milliseconds
                    cookieString += `; expires=${date.toUTCString()}`;
                } else if (options.expires instanceof Date) {
                    cookieString += `; expires=${options.expires.toUTCString()}`;
                }
            }
            if (options.path) cookieString += `; path=${options.path}`;
            if (options.secure) cookieString += '; secure';
            if (options.sameSite) cookieString += `; samesite=${options.sameSite}`;
        }

        document.cookie = cookieString;
    }

    hasCookie(key: string): boolean {
        const cookies = document.cookie.split('; ');
        return cookies.some(cookie => cookie.startsWith(`${encodeURIComponent(key)}=`));
    }

    deleteCookie(key: string, path?: string) {
        const options = { expires: new Date(0), path };
        this.setCookie(key, '', options);
    }

    getCookie(key: string): string | undefined {
        const cookies = document.cookie.split('; ');
        for (const cookie of cookies) {
            const [cookieKey, cookieValue] = cookie.split('=');
            if (decodeURIComponent(cookieKey) === key) {
                return decodeURIComponent(cookieValue);
            }
        }
        return undefined;
    }
}
